// The names this section uses are a setting ("inventory_names"), so the shop can rename
// them. The words here are only what shows if that setting has not been loaded.

import type { OrderState } from '@zerogap/engine';
import { useSession } from '../../lib/session';

export interface InventoryNames {
  rail: string;
  purchasing: string;
  stock: string;
  supply_demand: string;
  firm: string;
  committed: string;
  likely: string;
  safety_stock: string;
  order_quantity: string;
  kanban_card: string;
}

const FALLBACK: InventoryNames = {
  rail: 'Inventory',
  purchasing: 'Purchasing',
  stock: 'Stock',
  supply_demand: 'Supply & Demand',
  firm: 'firm',
  committed: 'committed',
  likely: 'likely',
  safety_stock: 'safety stock',
  order_quantity: 'order quantity',
  kanban_card: 'kanban card',
};

export function useInventoryNames(): InventoryNames {
  const { setting } = useSession();
  return { ...FALLBACK, ...(setting<Partial<InventoryNames>>('inventory_names', {}) ?? {}) };
}

/** What the five order states are called. The keys are fixed (the state is worked out); the names are a setting. */
const STATE_FALLBACK: Record<OrderState, string> = { draft: 'Draft', placed: 'Placed', partly_received: 'Partly received', received: 'Received', closed: 'Closed' };

export function useOrderStateNames(): Record<OrderState, string> {
  const { setting } = useSession();
  return { ...STATE_FALLBACK, ...(setting<Partial<Record<OrderState, string>>>('po_state_names', {}) ?? {}) };
}

/** "safety stock" → "Safety stock", for a label that starts a line. */
export function cap(text: string): string {
  return text.charAt(0).toUpperCase() + text.slice(1);
}
